export const FINISH_SETUP_TITLE = 'Almost there!';

export const FINISH_SETUP_CTA = 'Finish setup';

export const FINISH_SETUP_DESCRIPTION =
  'Finish setting up your company to send jobs to customers';
